import { useEffect, useState } from "react";
import { PhoneCTA, WhatsAppCTA } from "@/components/ContactButtons";

const MobileBar = () => {
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => setKeyboardOpen(window.innerHeight - vv.height > 150);
    vv.addEventListener("resize", onResize);
    return () => vv.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <div className="h-[76px] lg:hidden" aria-hidden="true" />
      <div
        data-testid="mobile-bar"
        className={`fixed bottom-0 inset-x-0 z-40 lg:hidden transition-transform duration-300 ${
          keyboardOpen ? "translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="grid grid-cols-2 gap-2.5 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] bg-[#f6f3ec]/95 backdrop-blur-md border-t border-[#e5e1d8]">
          <PhoneCTA location="mobile_bar" label="Appeler" className="w-full !px-4 !py-3.5" />
          <WhatsAppCTA location="mobile_bar" label="WhatsApp" className="w-full !px-4 !py-3.5" />
        </div>
      </div>
    </>
  );
};

export default MobileBar;
